import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { Button } from '@resurs/midas-react'
import { connect } from 'react-redux'
import { getText } from '../../../../internal/TextLabels'
import SendMailModalForm from '../../../../components/SendMailModalForm'
import { CustomerTypeModel } from '../../../PayApply/models/private-models'
import { format } from '../../../../models/format'
import { sendReceiptSummary } from '../../../../store/actions/receipt-summary-actions'
import { sendDebitConfirmationEvent } from '../../../../util/ga-helpers'

const getEmailAddress = props => {
  if (
    props.transaction.paymentMethod.customerType === CustomerTypeModel.NATURAL
  ) {
    return props.transaction.customer.email || ''
  }
  return ''
}

const SendDebitConfirmation = props => {
  const [showSendEmailModal, setShowSendEmailModal] = useState(false)
  const [emailAddress, setEmailAddress] = useState(getEmailAddress(props))

  const isValidEmail = () => {
    return emailAddress.match(format.email.regex)
  }

  useEffect(() => {
    if (showSendEmailModal) {
      sendDebitConfirmationEvent('Impression', props.transaction)
    }
  }, [showSendEmailModal])

  return (
    <>
      <SendMailModalForm
        inputValue={emailAddress}
        onChange={val => {
          setEmailAddress(val)
        }}
        onSubmit={() => {
          sendDebitConfirmationEvent('Send', props.transaction)
          props.sendReceiptSummary(props.transaction.id, props.index, {
            email: emailAddress,
          })
          setShowSendEmailModal(false)
        }}
        onClose={() => setShowSendEmailModal(false)}
        disableInput={!isValidEmail()}
        show={showSendEmailModal}
        disabled={false}
      />
      <Button
        onClick={() => {
          setShowSendEmailModal(true)
        }}
        type="link"
      >
        {' '}
        {getText('transactions.transaction.history.sendDebitReceipt')}
      </Button>
    </>
  )
}

SendDebitConfirmation.propTypes = {
  index: PropTypes.number.isRequired,
  sendReceiptSummary: PropTypes.func.isRequired,
  transaction: PropTypes.object.isRequired,
}

const mapDispatchToProps = dispatch => ({
  sendReceiptSummary: (paymentId, index, email) => {
    dispatch(sendReceiptSummary(paymentId, index, email))
  },
})

const mapStateToProps = state => {
  return {
    transaction: state.transactions.currentTransactionDetails,
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(SendDebitConfirmation)
